/** @jsxRuntime classic */
/** @jsx jsx */
import { gql } from '@apollo/client';
import { graphql } from 'gatsby';
import { jsx } from 'theme-ui';
import ProductShopExternalButton from './ProductShopExternalButton';

/** A shop button for an external online shop.*/
export default function ProductShopButton({ product, ...rest }) {
  return <ProductShopExternalButton product={product} {...rest} />;
}

export const fragment = graphql`
  fragment bb_ProductShopButton on Bottlebooks_Product {
    ...bb_ProductShopExternalButton
  }
`;

ProductShopButton.fragment = gql`
  fragment ProductShopButton on Product {
    ...ProductShopExternalButton
  }
  ${ProductShopExternalButton.fragment}
`;
